module.exports = __webpack_public_path__ + "media/app/images/success_payment-0e5a3c465e40e90883e15085b42b94fd.png";